export default __webpack_public_path__ + "static/background1_small-702d41af0827789029d31c3d9eabd818.jpg";